/**
 * Drilldown banner for the Creatives tab.
 * Shows when navigated from another tab with drilldown params
 * (drilldownGate, drilldownVerdict, drilldownAttribute).
 *
 * FR-77: Dismiss button clears drilldown params via context.
 */

import { X } from 'lucide-react';

import { useDashboardContext } from '@/pages/dashboard/DashboardContext';

// ============================================================================
// COMPONENT
// ============================================================================

export function DrilldownBanner() {
  const { filters, clearDrilldown } = useDashboardContext();

  const { drilldownGate, drilldownVerdict, drilldownAttribute } = filters;

  // No drilldown active
  if (!drilldownGate && !drilldownVerdict && !drilldownAttribute) {
    return null;
  }

  // Build description
  const parts: string[] = [];
  if (drilldownGate) parts.push(`Gate: ${drilldownGate}`);
  if (drilldownVerdict) parts.push(`Verdict: ${drilldownVerdict}`);
  if (drilldownAttribute) {
    const [field, value] = drilldownAttribute.split(':');
    parts.push(`${field}: ${value}`);
  }

  return (
    <div className="flex items-center gap-2 rounded-[10px] bg-brand/5 border border-brand/20 px-3 py-2">
      <span className="text-xs text-brand">
        Showing creatives filtered by: {parts.join(' | ')}
      </span>
      <button
        onClick={clearDrilldown}
        className="ml-auto p-0.5 rounded hover:bg-brand/10 text-brand transition-colors"
        aria-label="Clear drilldown filter"
      >
        <X size={14} />
      </button>
    </div>
  );
}
